// extracted by mini-css-extract-plugin
export default {"downloadAppSection":"RK6gRTtmLuzTa1P_RfqS","infoContainer":"cG8cgVDSS_GRcqbkWXPg","coinsPhone":"ZezgyqibkP48MGHfjo4J","textWrapper":"Bk0QQU7f1OjAJ8MqhOlZ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"downloadAppSection\":\"RK6gRTtmLuzTa1P_RfqS\",\"infoContainer\":\"cG8cgVDSS_GRcqbkWXPg\",\"coinsPhone\":\"ZezgyqibkP48MGHfjo4J\",\"textWrapper\":\"Bk0QQU7f1OjAJ8MqhOlZ\"}";
        // 1755964983642
        var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  